<template>
  <div>
    <tree-item
      v-if="!loading"
      class="item mt-3"
      :item="tree"
      :selected="selectedGroup"
      :groupMood="groupMood"
      @get-children="getChildren"
      @edit-group="editGroup"
      @add-group="addGroup"
      @add-office="addOffice"
      @add-user="addUser"
      @add-massive-users="addMassiveUsers"
      @remove-user="removeUser"
      @remove-group="removeGroup"
      @leader-group="leaderGroup"
      @add-sub-group="addSubGroup"
      @users-group="usersGroup"
      @config-numeration="configNumeration"
      @config-entity-doc-digital="entityDocDigital"
    />
    <div class="d-flex justify-content-center" >
      <b-spinner
        class="mt-4"
        variant="primary"
        size="sm"
        v-if="loading"
      />
    </div>
    <b-modal
      size="lg"
      ref="numeration"
      hide-footer
      no-close-on-backdrop
      :title="`Numeración para el grupo ${selectedGroup.nombre}`"
    >
      <NumerationConfig
        v-if="selectedGroup"
        :group="selectedGroup"
      />
    </b-modal>
    <b-modal
      centered
      size="lg"
      ref="group"
      hide-footer
      no-close-on-backdrop
      :title="groupMood
        ? `Datos del grupo ${selectedGroup.nombre}`
        : 'Datos de la oficina'"
    >
      <manage-group
        v-if="selectedGroup && action && !manageOffice"
        :group="selectedGroup"
        :name="selectedGroup.nombre"
        :action="action"
        @close-action="closeModal"
      />
      <manage-office
        v-if="selectedGroup && action && manageOffice"
        :group="selectedGroup"
        :name="selectedGroup.nombre"
        :action="action"
        @close-action="closeModal"
        data-cy="manage-office"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="user"
      hide-footer
      no-close-on-backdrop
      title="Datos del usuario"
      noCloseOnEsc
      centered
    >
      <manage-user
        :action="actionUser"
        :user="user"
        :group="selectedGroup"
        @close-manage-user="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="manageMassiveUsersModal"
      hide-footer
      no-close-on-backdrop
      title="Acción Masiva"
      noCloseOnEsc
      centered
    >
      <manage-massive-users
        @close-manage-massive-users="cerrarModalMasivoYToast"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="removeUser"
      hide-footer
      no-close-on-backdrop
      title="Datos del usuario"
    >
      <remove-user
        :action="actionUser"
        :user="user"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="removeGroup"
      hide-footer
      no-close-on-backdrop
      title="Remover grupo/oficina"
    >
      <remove-group
        :action="action"
        :group="selectedGroup"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="groupUsers"
      hide-footer
      no-close-on-backdrop
      title="Usuarios del grupo"
    >
      <users-group
        :usersGeneral="usersGeneral"
        :group="selectedGroup"
      />
    </b-modal>
    <b-modal
      size="lg"
      ref="leaderGroup"
      hide-footer
      no-close-on-backdrop
      :title="`Líder para el grupo ${selectedGroup.nombre}`"
    >
      <leader-form
        :group="selectedGroup"
        @close-action="closeModal"
      />
    </b-modal>
    <b-modal
      centered
      size="lg"
      ref="configEntityDocDigital"
      hide-footer
      no-close-on-backdrop
      title="Configurar entidad Doc Digital"
      @close-action="closeModal"
    >
      <entity-doc-digital-form
        :group="selectedGroup"
        @close-action="closeModal"
        data-cy="entity-doc-digital-form"
      />
    </b-modal>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

import TreeItem from '@/febos/global/management/vistas/components/TreeItem';
import NumerationConfig from '@/febos/global/management/vistas/components/NumerationConfig';
import ManageGroup from '@/febos/global/management/vistas/components/ManageGroup';
import ManageOffice from '@/febos/global/management/vistas/components/ManageOffice';
import ManageUser from '@/febos/global/management/vistas/components/ManageUser';
import ManageMassiveUsers from '@/febos/global/management/vistas/components/ManageMassiveUsers';
import RemoveUser from '@/febos/global/management/vistas/components/RemoveUser';
import RemoveGroup from '@/febos/global/management/vistas/components/RemoveGroup';
import UsersGroup from '@/febos/global/management/vistas/components/UsersGroup';
import LeaderForm from '@/febos/global/management/vistas/components/LeaderForm';
import EntityDocDigitalForm from '@/febos/global/management/vistas/components/EntityDocDigitalForm';

export default {
  components: {
    TreeItem,
    NumerationConfig,
    ManageGroup,
    ManageUser,
    ManageMassiveUsers,
    RemoveUser,
    RemoveGroup,
    UsersGroup,
    ManageOffice,
    LeaderForm,
    EntityDocDigitalForm
  },
  props: {
    groupMood: Boolean
  },
  data() {
    return {
      loading: true,
      treeView: true,
      tree: {
        nombre: '',
        children: []
      },
      action: '',
      actionUser: '',
      user: {},
      usersGeneral: [],
      selectedGroup: {},
      manageOffice: false,
      offices: []
    };
  },
  watch: {
    groupsCompany(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.tree.children = this.makeTree();
      }
    },
    groupMood() {
      this.tree.children = this.makeTree();
    }
  },
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'usersCompany',
      'usersCompanyAssign',
      'groupsCompany',
      'firstGroupsCompany'
    ])
  },
  methods: {
    ...mapActions('Empresas', [
      'getUsersCompany',
      'getUsersCompanyToAssign',
      'getGroupsCompany',
      'getUsersGroup',
      'setElement'
    ]),
    ...mapActions('Management', [
      'getDocConfigSheet',
      'fetchAllDocuments'
    ]),
    ...mapActions('docDigital', [
      'fetchOptionsMyEntityDocDigital'
    ]),
    async closeModal(event) {
      this.loading = true;
      if (event) {
        this.$bvToast.toast(
          'Usuario agregado correctamente',
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 5000
          }
        );
        this.$refs.user.hide();
        this.loading = false;
        return;
      }
      if (this.$refs.removeUser) {
        this.$refs.removeUser.hide();
      }
      if (this.$refs.group) {
        this.$refs.group.hide();
      }
      if (this.$refs.removeGroup) {
        this.$refs.removeGroup.hide();
      }
      if (this.$refs.leaderGroup) {
        this.$refs.leaderGroup.hide();
      }
      if (this.$refs.configEntityDocDigital) {
        this.$refs.configEntityDocDigital.hide();
      }
      await this.getGroupsCompany({
        empresaId: this.company.id
      });
      this.fillTree();
      this.loading = false;
    },
    cerrarModalMasivoYToast() {
      if (this.$refs.manageMassiveUsersModal) {
        this.$refs.manageMassiveUsersModal.hide();
      }
      this.$bvToast.toast(
        'Se te avisará por correo cuando termine el proceso completo.',
        {
          title: '¡Operación realizada!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 5000
        }
      );
    },
    async configNumeration(item) {
      this.configSheets = true;
      this.selectedGroup = { ...item };
      await this.getDocConfigSheet({ id: this.selectedGroup.id });
      await this.fetchAllDocuments();
      await this.$refs.numeration.show();
    },
    leaderGroup(item) {
      this.selectedGroup = { ...item };
      this.getUsersGroup({
        empresaId: this.company.id,
        pagina: 1,
        filas: 20,
        groupId: item.id
      });
      this.$refs.leaderGroup.show();
    },
    removeGroup(item) {
      this.action = 'remove';
      this.selectedGroup = { ...item };
      this.$refs.removeGroup.show();
    },
    removeUser() {
      this.user = {};
      this.actionUser = 'remove';
      this.$refs.removeUser.show();
    },
    addUser(item) {
      this.selectedGroup = { ...item };
      this.user = {};
      this.actionUser = 'add';
      this.$refs.user.show();
    },
    addMassiveUsers(item) {
      this.selectedGroup = { ...item };
      this.user = {};
      this.actionUser = 'addMassiveUsers';
      this.$refs.manageMassiveUsersModal.show();
    },
    addGroup(item) {
      this.selectedGroup = { ...item };
      this.action = 'addParent';
      this.selectedGroup = {
        nombre: '',
        descripcion: '',
        codigo: ''
      };
      this.manageOffice = false;
      this.$refs.group.show();
    },
    addOffice(item) {
      this.selectedGroup = { ...item };
      this.action = 'addParent';
      this.selectedGroup = {
        nombre: '',
        descripcion: '',
        codigo: ''
      };
      this.manageOffice = true;
      this.$refs.group.show();
    },
    addSubGroup(item) {
      this.selectedGroup = { ...item };
      this.action = 'add';
      const padreId = this.selectedGroup.id;
      const parentName = this.selectedGroup.nombre;
      this.selectedGroup = {
        nombre: '',
        descripcion: '',
        codigo: '',
        isOffice: false,
        padreId,
        padreNombre: parentName
      };
      this.$refs.group.show();
    },
    editGroup(item) {
      this.selectedGroup = { ...item };
      this.action = 'edit';
      this.manageOffice = item.esOficina === 'Y' || item.esOficina === 'si';
      this.$refs.group.show();
    },
    async entityDocDigital(item) {
      this.selectedGroup = { ...item };
      this.$refs.configEntityDocDigital.show();
      await this.fetchOptionsMyEntityDocDigital();
    },
    async usersGroup(item) {
      this.selectedGroup = { ...item };
      await this.getUsersCompanyToAssign({
        empresaId: this.company.id,
        pagina: 1,
        filas: 100000
      });
      this.getUsersGroup({
        empresaId: this.company.id,
        pagina: 1,
        filas: 100000,
        groupId: item.id
      });
      this.usersGeneral = this.usersCompanyAssign;
      this.$refs.groupUsers.show();
    },
    async getChildren(item) {
      this.selectedGroup = { ...item };
      if (item.nombre !== this.company.razonSocial) {
        if (!item.id) return;
        await this.getUsersGroup({
          empresaId: this.company.id,
          pagina: 1,
          filas: 20,
          groupId: item.id
        });
        this.$emit('select', this.selectedGroup);
      } else {
        await this.getUsersCompany({
          empresaId: this.company.id,
          pagina: 1,
          filas: 20,
          buscarInfoExtra: 'si',
          filtroInfoExtra: 'CARGO'
        });
        this.$emit('select', this.selectedGroup);
      }
    },
    checkParent(groupNode) {
      if (!this.groupMood) {
        return this.groupsCompany
          .filter((group) => (group.esOficina === 'Y' || group.esOficina === 'si')
            && group.padreId === groupNode.id)
          .map((group) => ({
            ...group,
            children: this.checkParent(group)
          }));
      }
      return this.groupsCompany
        .filter((group) => (group.esOficina === 'N' || group.esOficina === 'no' || !group.esOficina)
          && group.padreId === groupNode.id)
        .map((group) => ({
          ...group,
          children: this.checkParent(group)
        }));
    },
    makeTree() {
      if (!this.groupMood) {
        this.offices = this.groupsCompany
          .filter((group) => group.esOficina === 'Y' || group.esOficina === 'si');
        const regionNames = [...new Set(this.offices
          .filter((group) => group.regionNombre).map((group) => group.regionNombre))];

        const mappedOffices = regionNames.map((regionName) => ({
          type: 'category',
          nombre: regionName,
          children: [...new Set(this.offices
            .filter((group) => group.regionNombre === regionName)
            .map((group) => group.servicioNombre))
          ].map((serviceName) => ({
            type: 'subcategory',
            nombre: serviceName,
            children: this.offices
              .filter((group) => group.regionNombre === regionName
                      && group.servicioNombre === serviceName)
          }))
        }));
        mappedOffices.push(
          ...this.offices.filter((office) => !office.regionId && !office.servicioId)
        );
        return mappedOffices;
      }
      return this.firstGroupsCompany
        .filter((group) => group.esOficina === 'N' || group.esOficina === 'no' || !group.isOffice)
        .filter((group) => !group.regionId && !group.servicioId)
        .map((group) => ({
          ...group,
          showOpen: true,
          children: this.checkParent(group)
        }));
    },
    fillTree() {
      this.tree = {};
      this.tree.nombre = this.company.razonSocial;
      this.tree.isRoot = true;
      this.tree.children = this.makeTree();
    },
  },
  async created() {
    await this.getGroupsCompany({
      empresaId: this.company.id
    });
    this.fillTree();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  }
};
</script>

<style scoped>
.item {
  cursor: pointer;
  list-style: none;
}
</style>
